import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pager({ page, pageSize, total, onChange, testid }) {
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  if (pageCount <= 1) return null;
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(total, page * pageSize);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-slate-200 px-4 py-3" data-testid={testid}>
      <p className="text-xs text-slate-500">
        Showing <span className="font-semibold text-slate-700">{start}–{end}</span> of{" "}
        <span className="font-semibold text-slate-700">{total}</span>
      </p>
      <div className="flex items-center gap-2">
        <button type="button" data-testid={`${testid}-prev`} disabled={page <= 1} onClick={() => onChange(page - 1)}
          className="dm-btn-ghost !px-3 !py-1.5 disabled:opacity-40">
          <ChevronLeft size={14} /> Prev
        </button>
        <span className="font-mono text-xs text-slate-500">Page {page} of {pageCount}</span>
        <button type="button" data-testid={`${testid}-next`} disabled={page >= pageCount} onClick={() => onChange(page + 1)}
          className="dm-btn-ghost !px-3 !py-1.5 disabled:opacity-40">
          Next <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
}
